module.exports = __webpack_public_path__ + "static/media/Lu_Leao.cf9407ad.png";